import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "./Reducer/rootReducer";
import { APICallStatus } from "../Types/UnitFeatureTypes";


export const fetchServiceRequest = createSelector(
    (state: RootState) => state.fetchServiceRequest.request.data,
    (serviceRequestsData) => serviceRequestsData || []
);
export const fetchServiceRequestCount = createSelector(
    (state: RootState) => state.fetchServiceRequest.request.count,
    (serviceRequestsCount) => serviceRequestsCount || []
);

export const fetchServiceRequestUpdates = createSelector(
    (state: RootState) => state.fetchServiceRequestUpdates.request.data,
    (serviceRequestUpdatesData) => serviceRequestUpdatesData || []
);

export const fetchAnnouncement = createSelector(
    (state: RootState) => state.fetchAnnouncement.request.data,
    (announcementsData) => announcementsData || []
);

export const fetchAnnouncementCount = createSelector(
    (state: RootState) => state.fetchAnnouncement.request.count,
    (serviceRequestsCount) => serviceRequestsCount || []
);

export const fetchVisitorParking = createSelector(
    (state: RootState) => state.fetchVisitorParking.request.data,
    (visitorParkingData) => visitorParkingData || []
);

export const fetchVisitorParkingCount = createSelector(
    (state: RootState) => state.fetchVisitorParking.request.count,
    (visitorParkingCount) => visitorParkingCount || []
);

export const fetchBooking = createSelector(
    (state: RootState) => state.fetchBooking.request.data,
    (bookingData) => bookingData || []
);

export const fetchBookingCount = createSelector(
    (state: RootState) => state.fetchBooking.request.count,
    (bookingCount) => bookingCount || []
);

export const fetchBookingSingle = createSelector(
    (state: RootState) => state.fetchBooking.request.singleBooking,
    (singleBooking) => singleBooking || []
);

export const fetchViolation = createSelector(
    (state: RootState) => state.fetchViolation.request.data,
    (violationsData) => violationsData || []
);

export const fetchViolationCount = createSelector(
    (state: RootState) => state.fetchViolation.request.count,
    (violationsCount) => violationsCount || []
);

export const fetchUnit = createSelector(
    (state: RootState) => state.fetchUnit.request.data,
    (unitsData) => unitsData || []
);

export const announcementId = createSelector(
    (state: RootState) => state.announcement.request.announcementId,
    (announcementId) => announcementId || ''
);

export const fetchAmenities = createSelector(
    (state: RootState) => state.fetchAmenitiesList.request.data,
    (amenitiesData) => amenitiesData || []
);

export const bookingHoldId = createSelector(
    (state: RootState) => state.booking.request.bookingHoldId,
    (bookingHoldId) => bookingHoldId || []
);

export const bookingHoldRequestStatus = createSelector(
    (state: RootState) => state.booking.request.bookingHoldStatus,
    (bookingHoldSuccess) => bookingHoldSuccess || APICallStatus.PENDING
);

export const bookingUpdateRequestStatus = createSelector(
    (state: RootState) => state.booking.request.bookingUpdateStatus,
    (bookingUpdateStatus) => bookingUpdateStatus || APICallStatus.PENDING
);

export const bookingUpdateHoldRequestStatus = createSelector(
    (state: RootState) => state.booking.request.bookingUpdateHoldStatus,
    (bookingUpdateHoldStatus) => bookingUpdateHoldStatus || APICallStatus.PENDING
);

export const bookingCreateRequestStatus = createSelector(
    (state: RootState) => state.booking.request.bookingCreateStatus,
    (bookingCreateStatus) => bookingCreateStatus || APICallStatus.PENDING
);

export const bookingHoldError = createSelector(
    (state: RootState) => state.booking.request.bookingHoldError,
    (bookingHoldError) => bookingHoldError || ''
);

export const blockedSlots = createSelector(
    (state: RootState) => state.fetchAmenitiesList.request.blockedSlots,
    (blockedSlots) => blockedSlots || []
);

export const user = createSelector(
    (state: RootState) => state.fetchUser.request.data,
    (userData) => userData || []
);

export const userToken = createSelector(
    (state: RootState) => state.fetchUser.request.token,
    (userToken) => userToken || ''
);

export const userIsLoading = createSelector(
    (state: RootState) => state.fetchUser.request.loading,
    (isLoading) => isLoading || false
);

export const userError = createSelector(
    (state: RootState) => state.fetchUser.request.error,
    (error) => error || ''
);

export const currentUnit = createSelector(
    (state: RootState) => state.fetchUnit.request.userUnit,
    (unit) => unit || ''
);

export const singleAnnouncement = createSelector(
    (state: RootState) => state.fetchAnnouncement.request.singleAnnouncement,
    (singleAnnouncement) => singleAnnouncement || ''
);

export const singleServiceRequest = createSelector(
    (state: RootState) => state.fetchServiceRequest.request.singleServiceRequest,
    (singleServiceRequest) => singleServiceRequest || ''
);

export const singleVisitorParking = createSelector(
    (state: RootState) => state.fetchVisitorParking.request.singleVisitorParkingRequest,
    (singleVisitorParking) => singleVisitorParking || ''
);

export const singleBooking = createSelector(
    (state: RootState) => state.fetchBooking.request.singleBooking,
    (singleBooking) => singleBooking || ''
);

export const singleViolation = createSelector(
    (state: RootState) => state.fetchViolation.request.singleViolation,
    (singleViolation) => singleViolation || ''
);

export const approveBookingAPIStatus = createSelector(
    (state: RootState) => state.booking.request.approvalStatus,
    (approvalStatus) => approvalStatus || APICallStatus.PENDING
);

export const rejectBookingAPIStatus = createSelector(
    (state: RootState) => state.booking.request.rejectStatus,
    (rejectStatus) => rejectStatus || APICallStatus.PENDING
);

export const cancelBookingAPIStatus = createSelector(
    (state: RootState) => state.booking.request.cancelStatus,
    (cancelStatus) => cancelStatus || APICallStatus.PENDING
);

export const approveVisitorParkingAPIStatus = createSelector(
    (state: RootState) => state.visitorParking.request.approvalApiStatus,
    (approvalStatus) => approvalStatus || APICallStatus.PENDING
);

export const statusUpdateVisitorParkingAPIStatus = createSelector(
    (state: RootState) => state.visitorParking.request.statusUpdateApiStatus,
    (statusUpdateApiStatus) => statusUpdateApiStatus || APICallStatus.PENDING
);

export const statusUpdateViolationAPIStatus = createSelector(
    (state: RootState) => state.violation.request.updateStatusViolationApiStatus,
    (updateStatusViolationApiStatus) => updateStatusViolationApiStatus || APICallStatus.PENDING
);

export const createActionViolationAPIStatus = createSelector(
    (state: RootState) => state.violation.request.createViolationApiStatus,
    (createViolationApiStatus) => createViolationApiStatus || APICallStatus.PENDING
);

export const createServiceRequestAPIStatus = createSelector(
    (state: RootState) => state.createServiceRequest.request.createServiceRequestAPI,
    (createServiceRequestStatus) => createServiceRequestStatus || APICallStatus.PENDING
);

export const updateServiceRequestAPIStatus = createSelector(
    (state: RootState) => state.createServiceRequest.request.editServiceRequestAPI,
    (updateServiceRequestStatus) => updateServiceRequestStatus || APICallStatus.PENDING
);

export const sendAnnouncementAPIStatus = createSelector(
    (state: RootState) => state.announcement.request.sendAnnouncementAPIStatus,
    (sendAnnouncementAPIStatus) => sendAnnouncementAPIStatus || APICallStatus.PENDING
);

export const createToDoAPIStatus = createSelector(
    (state: RootState) => state.task.request.createTaskAPIStatus,
    (createToDoAPIStatus) => createToDoAPIStatus || APICallStatus.PENDING
);

export const updateToDoAPIStatus = createSelector(
    (state: RootState) => state.task.request.updateTaskAPIStatus,
    (updateToDoAPIStatus) => updateToDoAPIStatus || APICallStatus.PENDING
);

export const updateToDoStatusAPIStatus = createSelector(
    (state: RootState) => state.task.request.updateTaskStatusAPIStatus,
    (updateToDoStatusAPIStatus) => updateToDoStatusAPIStatus || APICallStatus.PENDING
);

export const fetchToDo = createSelector(
    (state: RootState) => state.fetchToDo.request.data,
    (toDoData) => toDoData || []
);

export const fetchToDoCount = createSelector(
    (state: RootState) => state.fetchToDo.request.count,
    (toDoCount) => toDoCount || ''
);

export const fetchToDoSingle = createSelector(
    (state: RootState) => state.fetchToDo.request.singleTask,
    (singleTask) => singleTask || ''
);

export const fetchViolationComments = createSelector(
    (state: RootState) => state.fetchViolation.request.comments,
    (comments) => comments || []
);

export const fetchBookingComments = createSelector(
    (state: RootState) => state.fetchBooking.request.comments,
    (comments) => comments || []
);

export const fetchEvents = createSelector(
    (state: RootState) => state.fetchEvent.request.data,
    (eventsData) => eventsData || []
);

export const fetchEventsCount = createSelector(
    (state: RootState) => state.fetchEvent.request.count,
    (eventsCount) => eventsCount || ''
);

export const fetchEventsSingle = createSelector(
    (state: RootState) => state.fetchEvent.request.singleEvent,
    (singleEvent) => singleEvent || ''
);

export const createEventAPIStatus = createSelector(
    (state: RootState) => state.event.request.createEventAPIStatus,
    (createEventAPIStatus) => createEventAPIStatus || APICallStatus.PENDING
);

export const updateEventAPIStatus = createSelector(
    (state: RootState) => state.event.request.editEventAPIStatus,
    (updateEventAPIStatus) => updateEventAPIStatus || APICallStatus.PENDING
);

export const deleteEventAPIStatus = createSelector(
    (state: RootState) => state.event.request.deleteEventAPIStatus,
    (deleteEventAPIStatus) => deleteEventAPIStatus || APICallStatus.PENDING
);

export const rsvpEventAPIStatus = createSelector(
    (state: RootState) => state.event.request.rsvpEventAPIStatus,
    (rsvpEventAPIStatus) => rsvpEventAPIStatus || APICallStatus.PENDING
);

export const createAnnouncementAPIStatus = createSelector(
    (state: RootState) => state.announcement.request.createAnnouncementAPIStatus,
    (createAnnouncementAPIStatus) => createAnnouncementAPIStatus || APICallStatus.PENDING
);

export const updateAnnouncementAPIStatus = createSelector(
    (state: RootState) => state.announcement.request.editAnnouncementAPIStatus,
    (updateAnnouncementAPIStatus) => updateAnnouncementAPIStatus || APICallStatus.PENDING
);